import {useDispatch, useSelector} from "react-redux"
import {excludedDrugs, includeDrug} from "redux/graphSlice"
import {Button, Table} from "antd"
import Label from "components/Label"
//import {label} from "services/label.service"
import {notesService} from "services/notes.service"
import {CloseCircleTwoTone} from "@ant-design/icons"
import { useTranslation } from 'react-i18next'

export default function ExcludedDrugs() {

	const dispatch = useDispatch()
	const { t } = useTranslation();
	const include = drug => {
		dispatch(includeDrug(drug))
		notesService.purgeNote(drug)
	}

	const columns = [
		{
			render: drug =>
				<Button className={`${drug} include-drug`} size="large" onClick={() => include(drug)}>
					<CloseCircleTwoTone twoToneColor="#ff0000"/>
				</Button>,
			width: "5%"
		},
		{
			title: t("graph.drug.excluded.title.drug"),
			render: drug => <Label id={drug}/>,
			width: 120
		}//,
		//{
		//	title: t("graph.drug.excluded.title.reason"),
		//	render: drug => <Note note={notesService.getNote(drug)}/>
		//}
	]

	const drugs = useSelector(excludedDrugs)

	const table = drugs.length > 0 ?
		<Table className="excluded-drugs" columns={columns} dataSource={drugs} pagination={false}/>
		: <div/>

	return (
		<div className="excluded-drugs">
			{table}
		</div>
	)
}

/*function Note({note}) {
	const { t } = useTranslation();
	return (
		<div>
			{note?.commonReasons?.map(r =>
				<div className="reason">
					{t(r)}
				</div>
			)}
			<div className="reason">
				{note.otherReasons}
			</div>
		</div>
	)
}*/
